module.exports = __webpack_public_path__ + "files/f052d83c24ec4bb771237fc08fda1da4.png";